module.exports = __webpack_public_path__ + "img/fig26.f1c2745d.jpg";